import { useContext } from "react"
import { quickLinksData1Props } from "@/app/types/types"
import { loadingContext } from "@/app/store/context/isLoadingContext"
// import Link from "next/link"
import { usePathname } from "next/navigation"
import Link from "../Link"
 
const QuickLinks = ({ data }: { data: quickLinksData1Props[] }) => {
	const {setIsPageFetched} = useContext(loadingContext)
	const pathname = usePathname()
	
	return (
		<div className="quick_links_container">
			<ul className="quick_links_list">
				{data.map((item , i) => (
					<li key={i} className={`quick_links_item capitalize text-white text-bodyM font-national mb-3 tracking-[0.1rem] font-normal ${pathname === item.route ? "font-semibold" : ""}`}>
						<Link href={item.route}>{item.label}</Link>
					</li>
				))}
			</ul>
		</div>
	)
}

export default QuickLinks
